/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/theme.js":
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
/***/ (() => {

if (typeof ProductRecommendations !== 'function') {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.loadRecommendations();
    }
    loadRecommendations() {
      const SUCCESS = new Event('product-recommendations-loaded');
      const FAIL = new Event('product-recommendations-error');
      fetch(this.dataset.url).then(response => response.text()).then(text => {
        const innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
        if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
          this.innerHTML = innerHTML.innerHTML;
          this.querySelectorAll('form').forEach(elm => {
            if (elm.querySelector('template')) {
              elm.append(elm.querySelector('template').content.cloneNode(true));
            }
          });
          this.dispatchEvent(SUCCESS);
        } else {
          this.dispatchEvent(FAIL);
        }
      }).catch(() => {
        this.dispatchEvent(FAIL);
      });
    }
  }
  if (typeof customElements.get('product-recommendations') == 'undefined') {
    customElements.define('product-recommendations', ProductRecommendations);
  }
}
if (typeof ProductRecommendations !== 'function') {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loadRecommendations(this.dataset.productId);
    }
    loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`).then(response => response.text()).then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      }).catch(e => {
        console.error(e);
      });
    }
  }
  if (typeof customElements.get('product-recommendations') == 'undefined') {
    customElements.define('product-recommendations', ProductRecommendations);
  }
}

/***/ }),

/***/ "./src/assets/scss/site1.scss":
/*!************************************!*\
  !*** ./src/assets/scss/site1.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/site1_pdp.scss":
/*!****************************************!*\
  !*** ./src/assets/scss/site1_pdp.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/account.scss":
/*!**************************************!*\
  !*** ./src/assets/scss/account.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/searchpage.scss":
/*!*****************************************!*\
  !*** ./src/assets/scss/searchpage.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/article.scss":
/*!**************************************!*\
  !*** ./src/assets/scss/article.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/image-athletes.scss":
/*!*********************************************!*\
  !*** ./src/assets/scss/image-athletes.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/mgn_footer.scss":
/*!*****************************************!*\
  !*** ./src/assets/scss/mgn_footer.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/video_reviews.scss":
/*!********************************************!*\
  !*** ./src/assets/scss/video_reviews.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/global.scss":
/*!*************************************!*\
  !*** ./src/assets/scss/global.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/mappy.scss":
/*!************************************!*\
  !*** ./src/assets/scss/mappy.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/pdp3cols.scss":
/*!***************************************!*\
  !*** ./src/assets/scss/pdp3cols.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/pdpbundle.scss":
/*!****************************************!*\
  !*** ./src/assets/scss/pdpbundle.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/old_theme.scss":
/*!****************************************!*\
  !*** ./src/assets/scss/old_theme.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/theme": 0,
/******/ 			"assets/old_theme": 0,
/******/ 			"assets/pdpbundle": 0,
/******/ 			"assets/pdp3cols": 0,
/******/ 			"assets/mappy": 0,
/******/ 			"assets/global": 0,
/******/ 			"assets/video_reviews": 0,
/******/ 			"assets/mgn_footer": 0,
/******/ 			"assets/image-athletes": 0,
/******/ 			"assets/article": 0,
/******/ 			"assets/searchpage": 0,
/******/ 			"assets/account": 0,
/******/ 			"assets/site1_pdp": 0,
/******/ 			"assets/site1": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkdawn_tailwind_starter"] = self["webpackChunkdawn_tailwind_starter"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/js/theme.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/global.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/mappy.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/pdp3cols.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/pdpbundle.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/old_theme.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/site1.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/site1_pdp.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/account.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/searchpage.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/article.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/image-athletes.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/mgn_footer.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/old_theme","assets/pdpbundle","assets/pdp3cols","assets/mappy","assets/global","assets/video_reviews","assets/mgn_footer","assets/image-athletes","assets/article","assets/searchpage","assets/account","assets/site1_pdp","assets/site1"], () => (__webpack_require__("./src/assets/scss/video_reviews.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;